// /*Author: Bhavya*/
// import React from "react";
// import {
//     CustomPrimaryButton as SaveButton,
//     CustomDatePicker as DatePicker,
//     CustomTextField as TextField,
//     CustomGrid as Grid,
//     CustomCell as Cell
// } from "../../customComponents/components";

// import SearchableSelect from "../../constants/searchableSelect";
// import Style from "../../constants/style";
// import Api from "../../constants/api";
// import SSOList from "../../constants/basicConfig";
// import moment from "moment";

// import LoginStore from "../../stores/loginstore";
// import * as LoginAction from "../../actions/loginaction";
// import UserInfoStores from "../../stores/userInfoStores";
// import Mapper from "../../constants/mapping";

// import Common from "../../constants/common";
// import Errors from "../../constants/error";

// import i18n from "../../i18nNext";

// export default class RegistrationPage extends React.Component {
//     constructor() {
//         super();
//         this.state = {
//             title: "Mr",
//             first_name: "",
//             middle_name: "",
//             last_name: "",
//             gender: "Male",
//             dob: "",
//             user_password: "",
//             confirm_password: "",
//             userNum: true,
//             userUpperAlpha: true,
//             userLowerAlpha: true,
//             useSpecialChar: true,
//             document_type: "",
//             document_id: ""
//         };
//         this._handleSubmit = this._handleSubmit.bind(this);
//     }

//     _handleSubmit(event) {
//         event.preventDefault();
//         let details = LoginStore._getField("details");
//         let obj = { ...this.state };
//         if (!obj.title) {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.pleaseSelectAnyTitle"));
//             return false;
//         } else if (!obj.first_name) {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.pleaseEnterFirstName"));
//             return false;
//         } else if (!obj.last_name) {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.PleaseEnterLastMame"));
//             return false;
//         } else if (!obj.gender) {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.pleaseSelectAnyGenderType"));
//             return false;
//         } else if (!obj.dob) {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.pleaseEnterDateOfBirth"));
//             return false;
//         } else if (!obj.user_password) {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.pleaseEnterUserPassword"));
//             return false;
//         } else if (UserInfoStores._getCardDetails() && !obj.document_type && !obj.document_id) {
//             UserInfoStores.showToast(i18n.t("err.FILL_MANDATORY_FIELDS"));
//             return false;
//         }
//         if (!UserInfoStores._minKycDocumentValidation(obj.document_type, obj.document_id)) {
//             return false;
//         }
//         let regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!#%*?&])(?=.{8,})");
//         if (!regex.test(obj.user_password.trim())) {
//             LoginAction.passwordMsg("errorMsg", Errors.passwordCorrectFormat);
//         } else if (
//             obj.user_password.trim() &&
//             obj.confirm_password.trim() &&
//             obj.user_password.trim() == obj.confirm_password.trim()
//         ) {
//             if (SSOList.isSSO()) {
//                 obj.sso = true;
//             }
//             obj.dob = moment(obj.dob).format("YYYY-MM-DD");
//             obj.invite_id = details && details.invite_id ? details.invite_id : Api._getKey("token");
//             obj.org_id = details.org_id;
//             obj.mobile_extension = LoginStore._getField("c_code");
//             LoginAction.registrationAPI(obj, details.is_superuser);
//         } else {
//             LoginAction.setAnyKey("errorMsg", i18n.t("err.passwordDidNotMatch"));
//         }
//     }

//     _focusElement(ele) {
//         this.refs[ele].focus();
//         return false;
//     }

//     _fieldOnChange(type, event, index, value) {
//         let formInputObj = {};
//         if (type === 1) formInputObj["title"] = value;
//         else if (type === 3) formInputObj["gender"] = value;
//         else if (type === 4) formInputObj["dob"] = index;
//         else if (type === 5) {
//             formInputObj[event.target.id] = index.trim();
//             if (event.target.id === "user_password" && !index.trim())
//                 formInputObj["confirm_password"] = "";
//         } else formInputObj[event.target.id] = index.trim();
//         this.setState(formInputObj);
//     }
//     _userMsg() {
//         let val = this.state.user_password,
//             arr = [];
//         let { userUpperAlpha, userLowerAlpha, userNum, useSpecialChar } = this.state;
//         if (!new RegExp("^(?=.*[a-z])").test(val)) {
//             userLowerAlpha = false;
//         }
//         if (!new RegExp("^(?=.*[A-Z])").test(val)) {
//             userUpperAlpha = false;
//         }
//         if (!new RegExp("^(?=.*[0-9])").test(val)) {
//             userNum = false;
//         }

//         if (!new RegExp("^(?=.*[$@$!#%*?^&])").test(val)) {
//             useSpecialChar = false;
//         }

//         if (
//             val &&
//             (!userNum || !userUpperAlpha || !userLowerAlpha || !useSpecialChar || val.length < 8)
//         ) {
//             arr.push(
//                 <div>
//                     {!userNum ? (
//                         <div>
//                             {`* ${i18n.t("err.numericCharacter")}`}
//                             <br />
//                         </div>
//                     ) : null}
//                     {!userUpperAlpha ? (
//                         <div>
//                             {`* ${i18n.t("err.uppercaseAlphabetCharacter")}`}
//                             <br />
//                         </div>
//                     ) : null}
//                     {!userLowerAlpha ? (
//                         <div>
//                             {`* ${i18n.t("err.lowercaseAlphabetCharacter")}`}
//                             <br />
//                         </div>
//                     ) : null}
//                     {!useSpecialChar ? (
//                         <div>
//                             {`* ${i18n.t("err.specialCharacter")}`}
//                             <br />
//                         </div>
//                     ) : null}
//                     {val.length < 8 ? <div>{`* ${i18n.t("err.atleastCharacter")}`}</div> : null}
//                 </div>
//             );
//         } else if (
//             val &&
//             userNum &&
//             userUpperAlpha &&
//             userLowerAlpha &&
//             useSpecialChar &&
//             val.length > 8
//         ) {
//             arr = [];
//         }
//         return arr;
//     }
//     _changeDocumentType = (event, index, value) => {
//         this.setState({
//             document_type: value,
//             document_id: ""
//         });
//     };
//     _changeDocumentId = (event, value) => {
//         this.setState({ document_id: value });
//     };

//     render() {
//         let cardAssign = UserInfoStores._getCardDetails() || false;
//         return (
//             <div style={Style.loginPage.mainContainer}>
//                 <div style={Object.assign({ overflowY: "scroll" }, Style.loginPage.leftContainer)}>
//                     <div style={Style.loginPage.logoDivStyle}>
//                         <div
//                             style={{
//                                 fontSize: 14,
//                                 fontFamily: "Roboto-Regular",
//                                 color: "#4a4a4a",
//                                 borderBottom: "1px solid rgba(74,74,74,0.23)"
//                             }}
//                         >
//                             {" "}
//                             {i18n.t("pageContent.registrationDetails")}
//                         </div>
//                     </div>
//                     <form onSubmit={this._handleSubmit.bind(this)} autoComplete="off">
//                         <div
//                             style={{
//                                 fontFamily: "Roboto-Regular",
//                                 fontSize: 14,
//                                 color: "#4a4a4a",
//                                 margin: 20
//                             }}
//                         >
//                             <div>
//                                 <SearchableSelect
//                                     type="single-select"
//                                     hideClearAll={true}
//                                     value={this.state.title}
//                                     onChange={this._fieldOnChange.bind(this, 1)}
//                                     floatingLabelText=" "
//                                     dataConfig={{ text: "name", value: "id" }}
//                                     data={Common.getSirname()}
//                                 />
//                             </div>
//                             <div>
//                                 <TextField
//                                     id="first_name"
//                                     ref="first_name"
//                                     fullWidth={true}
//                                     hintText={i18n.t("lbl.firstName")}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     value={this.state.first_name}
//                                     onChange={this._fieldOnChange.bind(this, 2)}
//                                     floatingLabelText={i18n.t("lbl.firstName")}
//                                 />
//                             </div>
//                             <div>
//                                 <TextField
//                                     id="middle_name"
//                                     ref="middle_name"
//                                     fullWidth={true}
//                                     hintText={i18n.t("lbl.middleName")}
//                                     value={this.state.middle_name}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     onChange={this._fieldOnChange.bind(this, 2)}
//                                     floatingLabelText={i18n.t("lbl.middleName")}
//                                 />
//                             </div>
//                             <div>
//                                 <TextField
//                                     id="last_name"
//                                     ref="last_name"
//                                     fullWidth={true}
//                                     hintText={i18n.t("lbl.lastName")}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     value={this.state.last_name}
//                                     onChange={this._fieldOnChange.bind(this, 2)}
//                                     floatingLabelText={i18n.t("lbl.lastName")}
//                                 />
//                             </div>
//                             <div>
//                                 <SearchableSelect
//                                     type="single-select"
//                                     hideClearAll={true}
//                                     value={this.state.gender}
//                                     floatingLabelText=" "
//                                     onChange={this._fieldOnChange.bind(this, 3)}
//                                     dataConfig={{ text: "name", value: "id" }}
//                                     data={Common.getGender()}
//                                 />
//                             </div>
//                             <div>
//                                 <DatePicker
//                                     id="dob"
//                                     value={this.state.dob}
//                                     floatingLabelText={i18n.t("lbl.enterDob")}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     hintText={i18n.t("lbl.enterDob")}
//                                     ref="dob"
//                                     maxDate={new Date()}
//                                     onChange={this._fieldOnChange.bind(this, 4)}
//                                     mode="landscape"
//                                     autoOk={true}
//                                 />
//                             </div>
//                             <div>
//                                 <TextField
//                                     id="user_password"
//                                     ref="user_password"
//                                     type="password"
//                                     fullWidth={true}
//                                     hintText={i18n.t("lbl.password")}
//                                     errorText={!this._userMsg().length ? "" : this._userMsg()}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     value={this.state.user_password}
//                                     onChange={this._fieldOnChange.bind(this, 5)}
//                                     floatingLabelText={i18n.t("lbl.password")}
//                                 />
//                             </div>
//                             <div>
//                                 <TextField
//                                     id="confirm_password"
//                                     ref="confirm_password"
//                                     type="password"
//                                     fullWidth={true}
//                                     errorText={
//                                         this.state.confirm_password &&
//                                         this.state.user_password.trim() !==
//                                             this.state.confirm_password.trim()
//                                             ? "Password is not matching"
//                                             : ""
//                                     }
//                                     disabled={this.state.user_password.trim() ? false : true}
//                                     hintText={i18n.t("lbl.confirmPassword")}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     value={this.state.confirm_password}
//                                     onChange={this._fieldOnChange.bind(this, 5)}
//                                     floatingLabelText={i18n.t("lbl.confirmPassword")}
//                                 />
//                             </div>
//                             <div>
//                                 <SearchableSelect
//                                     type="single-select"
//                                     id="document_type"
//                                     hideClearAll={false}
//                                     value={this.state.document_type}
//                                     onChange={this._changeDocumentType}
//                                     floatingLabelText={
//                                         cardAssign ? (
//                                             <span>
//                                                 {i18n.t("lbl.documentType")}{" "}
//                                                 <span className="required-input">*</span>
//                                             </span>
//                                         ) : (
//                                             i18n.t("lbl.documentType")
//                                         )
//                                     }
//                                     dataConfig={{ text: "name", value: "id" }}
//                                     data={Mapper["MIN_KYC_DOCUMENT"]}
//                                 />
//                             </div>
//                             <div>
//                                 <TextField
//                                     id="document_id"
//                                     fullWidth={true}
//                                     required={cardAssign}
//                                     floatingLabelText={i18n.t("currency.documentId")}
//                                     hintText={i18n.t("currency.documentId")}
//                                     disabled={this.state.document_type ? false : true}
//                                     floatingLabelStyle={Style.loginPage.floatingRegTextStyle}
//                                     underlineFocusStyle={Style.floatingUnderLineStyle}
//                                     value={this.state.document_id}
//                                     onChange={this._changeDocumentId}
//                                 />
//                             </div>
//                         </div>
//                         <div style={{ textAlign: "end" }}>
//                             <SaveButton type="submit" label={i18n.t("btn.submit")} />
//                         </div>
//                     </form>
//                 </div>
//                 <div style={Style.loginPage.regRightContainer}>
//                     <div style={{ marginBottom: 22, fontFamily: "Roboto-Medium", fontSize: 18 }}>
//                         {i18n.t("pageContent.theMantraRelationship")}
//                     </div>
//                     <Grid noSpacing>
//                         <Cell col={6}>
//                             <img src="/assets/images/request_advance.svg" />
//                         </Cell>
//                         <Cell
//                             col={6}
//                             style={{ paddingTop: 36, fontFamily: "Roboto-Regular", fontSize: 14 }}
//                         >
//                             <span style={{ fontSize: 20 }}>1 </span>{" "}
//                             {i18n.t("flexi.requestAdvance")}
//                         </Cell>
//                     </Grid>
//                     <Grid noSpacing>
//                         <Cell col={6}>
//                             <img src="/assets/images/create_helpexpense.svg" />
//                         </Cell>
//                         <Cell
//                             col={6}
//                             style={{ paddingTop: 36, fontFamily: "Roboto-Regular", fontSize: 14 }}
//                         >
//                             <span style={{ fontSize: 20 }}>2 </span>{" "}
//                             {i18n.t("pageContent.createExpenses")}
//                         </Cell>
//                     </Grid>
//                     <Grid noSpacing>
//                         <Cell col={6}>
//                             <img src="/assets/images/create_helpreport.svg" />
//                         </Cell>
//                         <Cell
//                             col={6}
//                             style={{ paddingTop: 36, fontFamily: "Roboto-Regular", fontSize: 14 }}
//                         >
//                             <span style={{ fontSize: 20 }}>3 </span>{" "}
//                             {i18n.t("pageContent.submitTheExpensesReport")}
//                         </Cell>
//                     </Grid>
//                 </div>
//             </div>
//         );
//     }
// }
//---------------- Start External Library Import --------------------//
import React from "react";
import RegistrationPage from "@techsoftware/happay-widgets/RegistrationPage";
//---------------- End External Library Import --------------------//

//------------------- Start Constants Dependency Import -------------------------------------//
import SSOList from "../../constants/basicConfig";
import Common from "../../constants/common";
import Mapper from "../../constants/mapping";
import Errors from "../../constants/error";
import Api from "../../constants/api";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";
//------------------- End Constants Dependency Import -------------------------------------//

//------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
//------------------- End Actions Dependency Import -------------------------------------//

//------------------- Start Stores Dependency Import -------------------------------------//
import LoginStore from "../../stores/loginstore";
import UserInfoStores from "../../stores/userInfoStores";
//------------------- End Stores Dependency Import -------------------------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
import moment from "moment";
//------------------- End Helpers Dependency Import -------------------------------------//

export default class registrationPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onSignIn = value => {
        let details = LoginStore._getField("details");
        if (UserInfoStores._getCardDetails() && !value.documentType && !value.documentID) {
            UserInfoStores.showToast(i18n.t("err.FILL_MANDATORY_FIELDS"));
            return false;
        }

        let reqData = {
            org_id: details?.org_id,
            title: value?.title,
            first_name: value?.firstName,
            middle_name: value?.middleName,
            last_name: value?.lastName,
            gender: value?.gender,
            user_password: value?.userPassword,
            confirm_password: value?.confirmPassword,
            document_type: value?.documentType,
            document_id: value?.documentID,
            dob: moment(value.dob).format("YYYY-MM-DD"),
            mobile_extension: details?.mobile_extension || LoginStore._getField("c_code"),
            invite_id: details && details.invite_id ? details.invite_id : Api._getKey("token")
        };

        if (
            value?.userPassword == value?.confirmPassword
        ) {
            if (SSOList.isSSO()) {
                reqData.sso = true;
            }
            LoginAction.registrationAPI(reqData, details.is_superuser);
        }
    };

    render() {
        const { ProductLogo, breakPoints } = this.props;
        const showDocumentType = LoginStore._getField("details")?.channel?.toLowerCase()?.includes("hs-qc") ? false : true;
        return (
            <RegistrationPage
                containerClassName={`signin-container ${
                    Common._checkIfHdfcUrl() ? "hdfcPortal" : "happayPortal"
                }`}
                logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                breakPoints={breakPoints}
                sirNameData={Common.getSirname()}
                genderNameData={Common.getGender()}
                documentTypeData={Mapper["MIN_KYC_DOCUMENT"]}
                onSignIn={this.onSignIn}
                uppercaseText={i18n.t("err.uppercaseLetter")}
                lowercaseText={i18n.t("err.lowercaseLetter")}
                specialText={i18n.t("err.atleastSpecialCharacter")}
                numberText={i18n.t("err.numericNumber")}
                lengthText={i18n.t("err.atleastCharacters")}
                titleErrorStr={i18n.t("err.pleaseSelectAnyTitle")}
                firstNameErrorStr={i18n.t("err.pleaseEnterFirstName")}
                lastNameErrorStr={i18n.t("err.pleaseEnterLastName")}
                genderErrorStr={i18n.t("err.pleaseSelectAnyGenderType")}
                dobErrorStr={i18n.t("err.pleaseEnterDateOfBirth")}
                userPasswordErrorStr={i18n.t("err.pleaseEnterUserPassword")}
                registrationHeader={i18n.t("logIn.createYourAccount")}
                titleLabelText={i18n.t("lbl.title")}
                titleHintText={i18n.t("placeholder.pleaseSelect")}
                firstNameFloatingLabelText={i18n.t("lbl.firstName")}
                firstNameHintText={i18n.t("placeholder.enterFirstName")}
                middleNameFloatingLabelText={i18n.t("lbl.middleName")}
                middleNameHintText={i18n.t("placeholder.enterMiddleName")}
                lastNameFloatingLabelText={i18n.t("lbl.lastName")}
                lastNameHintText={i18n.t("placeholder.enterLastName")}
                genderLabelText={i18n.t("lbl.gender")}
                genderHintText={i18n.t("placeholder.pleaseSelect")}
                dobFloatingLabelText={i18n.t("lbl.dateOfBirth")}
                dobPlaceholder={i18n.t("lbl.enterDob")}
                passwordFloatingLabelText={i18n.t("lbl.password")}
                userPasswordHintText={i18n.t("placeholder.enterPassword")}
                confirmPasswordFloatingLabelText={i18n.t("lbl.confirmPassword")}
                confirmPasswordHintText={i18n.t("lbl.confirmPassword")}
                documentTypeLabelText={i18n.t("lbl.documentType")}
                documentTypeHintText={i18n.t("placeholder.pleaseSelect")}
                documentIDFloatingLabelText={i18n.t("currency.documentId")}
                documentIDHintText={i18n.t("placeholder.enterDocumentID")}
                nextButtonText={i18n.t("btn.next")}
                showDocumentType={showDocumentType}
                showDocumentId={showDocumentType}
                drivingLicenseIFMsg={i18n.t("err.drivingLicenseIFMsg")}
                drivingLicenseElseMsg={i18n.t("err.drivingLicenseElseMsg")}
                panCardIFMsg={i18n.t("err.panCardIFMsg")}
                panCardElseMsg={i18n.t("err.panCardElseMsg")}
                voterIdIFMsg={i18n.t("err.voterIdIFMsg")}
                voterIdElseMsg={i18n.t("err.voterIdElseMsg")}
                passportIFMsg={i18n.t("err.passportIFMsg")}
                passportElseMsg={i18n.t("err.passportElseMsg")}
                passwordDidNotMatch={i18n.t("err.passwordDidNotMatch")}
                confirPasswordErrorStr={i18n.t("err.pleaseEnterConfirmpPassword")}
            />
        );
    }
}
